import { render } from "./LanguageSwitcher.vue?vue&type=template&id=85f47494&scoped=true&ts=true"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=ts"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=ts"

import "./LanguageSwitcher.vue?vue&type=style&index=0&id=85f47494&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85f47494"]])

export default __exports__